<script setup lang="ts">
const items = ref([
    [
        {
            label: 'Links',
            type: 'label'
        },
        {
            label: 'Profile',
            icon: 'i-lucide-user',
            to: '/profile'
        },
        {
            label: 'Aside',
            icon: 'i-lucide-book-open',
            to: '/aside'
        },
        {
            label: 'Composables',
            icon: 'i-lucide-database',
            children: [
                {
                    label: 'defineShortcuts',
                    icon: 'i-lucide-file-text',
                    description: 'Define shortcuts for your application.',
                },
                {
                    label: 'useOverlay',
                    icon: 'i-lucide-file-text',
                    description: 'Display a modal/slideover within your application.',
                },
                {
                    label: 'useToast',
                    icon: 'i-lucide-file-text',
                    description: 'Display a toast within your application.',
                }
            ]
        },
        {
            label: 'Components',
            icon: 'i-lucide-box',
            to: '/components',
            active: true,
            defaultOpen: true,
            children: [
                {
                    label: 'Link',
                    icon: 'i-lucide-file-text',
                    description: 'Use NuxtLink with superpowers.',
                },
                {
                    label: 'Modal',
                    icon: 'i-lucide-file-text',
                    description: 'Display a modal within your application.',
                },
                {
                    label: 'NavigationMenu',
                    icon: 'i-lucide-file-text',
                    description: 'Display a list of links.',
                },
                {
                    label: 'Pagination',
                    icon: 'i-lucide-file-text',
                    description: 'Display a list of pages.',
                },
                {
                    label: 'Popover',
                    icon: 'i-lucide-file-text',
                    description: 'Display a non-modal dialog that floats around a trigger element.',
                },
                {
                    label: 'Progress',
                    icon: 'i-lucide-file-text',
                    description: 'Show a horizontal bar to indicate task progression.',
                }
            ]
        }
    ],
    [
        {
            label: 'GitHub',
            icon: 'i-simple-icons-github',
            badge: '3.8k',
            to: 'https://github.com/nuxt/ui',
            target: '_blank'
        },
        {
            label: 'Help',
            icon: 'i-lucide-circle-help',
            disabled: true
        }
    ]
])
const coreStore = useTemplateStore()
</script>

<template lang="pug">
    UNavigationMenu.px-2(
        v-if="coreStore.sidebarSmValue"
        orientation="vertical" 
        :items="items" 
        class="data-[orientation=vertical]:w-52"
    )
    .flex.flex-1.h-full.flex-col.gap-2(
        v-else
    )
        slot(
            v-for="(item, index) in items"
            :key="`prt-${index}`"
        )
            .flex.justify-center(
                v-for="itm in item"
                :key="itm.label"
            )
                UTooltip(:delay-duration="0" :text="itm.label" v-if="itm.icon")
                    UButton(
                        color="neutral"
                        variant="ghost"
                        :icon="itm.icon"
                        :to="itm.to"
                    )
</template>
